import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

function initScrollFade() {
    const splitTargets = document.querySelectorAll('.scroll-highlight');

    splitTargets.forEach((target) => {
        const text = new SplitType(target, { types: ['chars', 'words'] });

        gsap.from(text.chars, {
            opacity: 0.2,
            stagger: 0.05,
            scrollTrigger: {
                trigger: target,
                start: "top 80%",
                end: "top 20%",
                scrub: true,
                markers: false
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", initScrollFade);
